import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { BehaviorSubject, Subject, throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserCourseDto, createUserCourseDto } from '@models/user-course-dto';
import { UserClassesTaken } from '@models/user-classes-taken';
import { ConfigurationService } from '@services/configuration.service';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserClassesService {
  baseUrl = environment.baseUrl + 'userclasses/';
  percentageObservable = new BehaviorSubject<number>(null); // Observable : list of reports
  dataPercentage = this.percentageObservable.asObservable(); //

  private navStateSource = new Subject<any>();
  navState$ = this.navStateSource.asObservable();

  constructor(
    private http: HttpClient, 
    private configurationService: ConfigurationService,
    private authService: AuthService
  ) { }

  GetAllUserClasses() {
    let u = this.http.get(this.baseUrl + "getAllUserClasses");
    // console.log(u);
    //return this.http.get(this.baseUrl );
    return u;
  }

  getCountriesList() {
    let u = this.http.get(this.baseUrl );
    // console.log(u);
    //return this.http.get(this.baseUrl );
    return u;
  }

  UpdateAllUserClassesTaken(userclassestaken: any[]) {
    let result = this.http.post(this.baseUrl + 'UpdateAllUserClassesTaken', userclassestaken);
    return result;
    // return "back again";
  }

  UpdateUserClassesTakenVideo(userClassesTaken: any) {
    return this.http.post(this.baseUrl + 'UpdateUserClassesTakenVideo', userClassesTaken);
    //return this.http.post(this.baseUrl + 'UpdateUserClassesTakenVideo3', null);
  }

  getVideoWatched(userId: number, classId: number) {
    let params = new HttpParams();
    params = params.append('userId', userId.toString());
    params = params.append('classId', classId.toString());
    return this.http.get(this.baseUrl + 'GetVideoWatched', { params });
  }

  UpdateUserClassesTakenVideoCompleted(userClassesTaken: any) {
    //Set one of the is...completed to true, logic in repository, if it is false set to the value given, if it is true dont change
    //if only one of these is set to true only one gets changed...
    //console.log('UpdateUserClassesTakenVideoCompleted :' + userClassesTaken.classId);
    //console.log(this.baseUrl + 'UpdateUserClassesTakenVideoCompleted');
    // console.log("handout_completed");
    // console.log(userClassesTaken);
    return this.http.post(this.baseUrl + 'UpdateUserClassesTakenVideoCompleted', userClassesTaken);
    //return this.http.post(this.baseUrl + 'UpdateUserClassesTakenVideo3', null);
  }

  //UpdateUserClassesTakenQuiz(userClassesTaken: any) {
  //  console.log('UpdateUserClassesTakenQuiz :' + userClassesTaken.classId);
  //  console.log(this.baseUrl + 'UpdateUserClassesTakenQuiz');

  //  return this.http.post(this.baseUrl + 'UpdateUserClassesTakenQuiz', userClassesTaken);
  //}

  //UpdateUserClassesTakenHandoutCompleted(userClassesTaken: any) {
      
  //  return this.http.post(this.baseUrl + 'UpdateUserClassesTakenHandoutCompleted', userClassesTaken);
  //}

  GetAllClassesTakenByUser(userId: number): Observable<UserClassesTaken[]> {
    let params = new HttpParams();
    params = params.append('userId', userId.toString());
    return this.http.get<UserClassesTaken[]>(this.baseUrl + 'GetAllClassesTakenByUser', { params });
  }

  getActiveClasses() {
    return this.http.get(this.baseUrl + 'GetActiveClasses');
  } 

  // Refactored to use cached enrollment data
  CheckAllClassesComplete(userCourseDto: UserCourseDto) {
    console.log('CheckAllClassesComplete called with enrollment data:', userCourseDto);
    let certificateSent = userCourseDto.isCertificateSent == 'false' ? 0 : 1; 
    console.log('Course completion status (0 or 1):', certificateSent);
    return this.http.get(this.baseUrl + 'CheckAllClassesComplete/' + userCourseDto.userId + "/" + userCourseDto.courseId + "/" + certificateSent );
  }

  GetAllClassesComplete(userCourseDto: UserCourseDto) {
    let courseComplete = userCourseDto.isCourseComplete == 'false' ? 0 : 1; 
    return this.http.get(this.baseUrl + 'GetAllClassesComplete/' + userCourseDto.userId + "/" + userCourseDto.courseId + "/" + courseComplete );
  }

  GetUserEnrolment(userId: number, courseId: number): Observable<UserCourseDto> {
    return this.http.get<UserCourseDto>(this.baseUrl + 'GetUserEnrolment/' + userId + '/' + courseId);
  }

  // Legacy method kept for backward compatibility
  returnProgress(progress: number, userCourseDto: UserCourseDto) {
    // check if student finishes all classes
    this.CheckAllClassesComplete(userCourseDto).subscribe((courseComplete: number) => {
      // set percentage
      let percentageWatched = courseComplete * 100 / 30;
      localStorage.setItem('percentage', percentageWatched.toString());

      // if (courseComplete == 30) {
      if (this.configurationService.isCourseComplete(courseComplete)) {

      }
      else {
        //update the task bar
      }
    }
    );
    //localStorage.getItem("user")
    progress = parseInt(localStorage.getItem("percentage"));
    //console.log('progress' + progress);
    this.percentageObservable.next(progress);
  }

  // GetCertificatePdf(userId: number) {
  //   return this.http.get(this.baseUrl + 'GetCertificatePdf/' + userId, { responseType: 'blob' })
  // }
  
  GetCertificatePdf(userId: number) {
    return this.http.get(this.baseUrl + 'GetCertificatePdf/' + userId, { 
      responseType: 'blob' 
    }).pipe(
      catchError(error => {
        console.error('Certificate API error:', error);
        return throwError(error);
      })
    );
  }

  CheckCertificateAvailability(userId: number) {
    return this.http.get<{available: boolean, reason?: string}>(
      this.baseUrl + 'CheckCertificateAvailability/' + userId
    );
  }
 
}